(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-table"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-ragavi-size-chart]').forEach((chart) => {
    if (chart.dataset.bound === 'true') return;
    chart.dataset.bound = 'true';

    chart.querySelectorAll('[data-unit]').forEach((button) => {
      button.addEventListener('click', () => {
        const unit = button.dataset.unit;
        chart.querySelectorAll('[data-unit]').forEach((item) => {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        chart.querySelectorAll('[data-in]').forEach((cell) => {
          cell.textContent = unit === 'cm' ? cell.dataset.cm : cell.dataset.in;
        });
      });
    });
  });

  if (window.ragaviCustomSizeBound !== true) {
    window.ragaviCustomSizeBound = true;
    const isCustomSizeValue = (value) => String(value || '').trim().toLowerCase() === 'custom size';
    const openCustomSizeWhatsApp = () => {
      const link = document.querySelector('[data-custom-size-whatsapp]');
      if (link && link.href) window.open(link.href, '_blank', 'noopener');
    };

    document.addEventListener(
      'click',
      (event) => {
        const input = event.target.closest('input[type="radio"]');
        const label = event.target.closest('label');
        let value = input ? input.value : '';
        if (!value && label && label.htmlFor) {
          const labelled = document.getElementById(label.htmlFor);
          value = labelled ? labelled.value : '';
        }
        if (!isCustomSizeValue(value)) return;
        event.preventDefault();
        event.stopPropagation();
        openCustomSizeWhatsApp();
      },
      true
    );

    document.addEventListener(
      'change',
      (event) => {
        const target = event.target;
        if (!target || !target.value) return;
        if (!isCustomSizeValue(target.value)) return;
        event.preventDefault();
        event.stopPropagation();
        if (target.tagName === 'SELECT') {
          const fallback = Array.from(target.options).find((option) => !isCustomSizeValue(option.value));
          if (fallback) target.value = fallback.value;
        } else if (target.checked) {
          target.checked = false;
        }
        openCustomSizeWhatsApp();
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
